import { defineStyle, defineStyleConfig } from "@chakra-ui/react";

const solid = defineStyle({
  fontSize: "15px",
  fontWeight: 500,
  px: 8,
  color: "background",
  borderRadius: "6px",
});
const outline = defineStyle({
  _hover: { bg: "par.50" },
});

const cancel = defineStyle({
  background: "transparent",
  fontSize: "14px",
  fontWeight: 400,
  color: "text.140",
  textDecoration: "underline",
  textUnderlineOffset: 2,
  textDecorationThickness: 1,
});

const normal = defineStyle({
  fontSize: { base: "16px", md: "14px" },
  fontWeight: 500,
  px: "6",
  h: { base: "12", md: "10" },
  borderRadius: "6px",
});

export const button = defineStyleConfig({
  baseStyle: {
    borderRadius: "6px",
    fontSize: "14px",
    _active: {
      transform: "scale(0.98)",
    },
    transition: "all 0.15s cubic-bezier(0.645,0.045,0.355,1)",
  },
  variants: { solid, outline, cancel },
  sizes: { normal },
  defaultProps: {
    colorScheme: "par",
    size: "normal",
  },
});
